import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import { jsx as _jsx } from "react/jsx-runtime";
export default function (_ref) {
  var className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    className: "anticon ".concat(className)
  }, rest), {}, {
    children: /*#__PURE__*/_jsx("svg", {
      width: "1em",
      height: "1em",
      fill: "currentColor",
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/_jsx("path", {
        d: "M271.002 424.602a51.2 51.2 0 0172.396 0L512 593.152l168.602-168.55a51.2 51.2 0 0167.584-4.25l4.812 4.25a51.2 51.2 0 010 72.396l-204.8 204.8a51.2 51.2 0 01-72.396 0l-204.8-204.8a51.2 51.2 0 010-72.396z"
      })
    })
  }));
}